import { Controller } from '@hotwired/stimulus';
import {
  applyMarketingConsentFromConsentData,
  grantedCategoriesFromConsentData,
  notifyFromConsentResponse,
  recreateScripts,
} from '../application/common/cookie_consent';

const PROVIDERS = {
  consent_studio: {
    event: 'consent-studio__updated',
  },
};

// Consent Studio: functional = necessary + preferences (always on).
// Optional opt-ins: analytics → statistics, marketing → marketing.
export function consentAttributesFromVendorCategories(grantedNames) {
  const granted = Array.isArray(grantedNames) ? grantedNames : [];

  return {
    preferences: true,
    statistics: granted.includes('analytics'),
    marketing: granted.includes('marketing'),
  };
}

export default class extends Controller {
  static values = { provider: String };

  connect() {
    this.config = PROVIDERS[this.providerValue];
    if (!this.config) {
      return;
    }

    this.boundSync = this.sync.bind(this);
    window.addEventListener(this.config.event, this.boundSync);
  }

  disconnect() {
    if (this.config) {
      window.removeEventListener(this.config.event, this.boundSync);
    }
  }

  sync(event) {
    const grantedNames = event && event.detail && event.detail.categories;
    if (!Array.isArray(grantedNames)) {
      return;
    }

    this.postConsent(
      '/cookies/adjust',
      consentAttributesFromVendorCategories(grantedNames),
    );
  }

  async postConsent(path, attributes) {
    const response = await fetch(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
      },
      credentials: 'same-origin',
      body: JSON.stringify(attributes),
    });

    const data = await response.json();
    notifyFromConsentResponse(data);
    applyMarketingConsentFromConsentData(data);

    if (path === '/cookies/adjust') {
      recreateScripts(grantedCategoriesFromConsentData(data));
    }
  }
}
